import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { switchMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { Action } from 'redux-actions';

import {
	GET_PERSONAL_PAYROLL_DETAIL_CALL,
	GET_PERSONAL_PAYROLL_LIST_CALL,
	GET_PAYSLIP_DISPLAY_SETTINGS_CALL,
	GET_PAYROLL_TASK_DISPLAY_SETTINGS_CALL,
} from '@src/store/types/payroll';
import {
	getPersonalPayrollDetail,
	getPersonalPayrollList,
	getPayslipDisplaySettings,
	getPayrollTaskDisplaySettings,
} from '@src/services/payroll';
import { toastShowCall } from '@src/store/actions/ui';
import { isAuthError } from '@src/utils/apiError';
import { TOAST_TYPE_ERROR } from '@src/const/common';
import {
	getPersonalPayrollListDone,
	getPersonalPayrollListFail,
	getPersonalPayrollDetailDone,
	getPersonalPayrollDetailFail,
	getPayslipDisplaySettingsDone,
	getPayslipDisplaySettingsFail,
	getPayrollTaskDisplaySettingsDone,
	getPayrollTaskDisplaySettingsFail,
} from '../actions/payroll';

export const getPersonalPayrollListEpic = (
	action$: Observable<Action>,
): Observable<Action> => action$.pipe(
	ofType(GET_PERSONAL_PAYROLL_LIST_CALL),
	switchMap(
		({ payload }) => fromPromise(getPersonalPayrollList(payload)).pipe(
			switchMap(res => of(getPersonalPayrollListDone({ res }))),
			catchError(error => of(getPersonalPayrollListFail({ error }))),
		),
	),
);

export const getPersonalPayrollDetailEpic = (
	action$: Observable<Action>,
): Observable<Action> => action$.pipe(
	ofType(GET_PERSONAL_PAYROLL_DETAIL_CALL),
	switchMap(
		({ payload }) => fromPromise(getPersonalPayrollDetail(payload)).pipe(
			switchMap(res => of(getPersonalPayrollDetailDone({ res }))),
			catchError(error => {
				if (payload.onError) payload.onError(error.response);
				if (isAuthError(error.response)) return of(getPersonalPayrollDetailFail({ error }));
				return of(
					toastShowCall({ message: 'common:message:action_failed', type: TOAST_TYPE_ERROR }),
					getPersonalPayrollDetailFail({ error }),
				);
			}),
		),
	),
);

export const getPayslipDisplaySettingsEpic = (
	action$: Observable<Action>,
): Observable<Action> => action$.pipe(
	ofType(GET_PAYSLIP_DISPLAY_SETTINGS_CALL),
	switchMap(
		() => fromPromise(getPayslipDisplaySettings()).pipe(
			switchMap(res => of(getPayslipDisplaySettingsDone({ res }))),
			catchError(error => of(getPayslipDisplaySettingsFail({ error }))),
		),
	),
);

export const getPayrollTaskDisplaySettingsEpic = (
	action$: Observable<Action>,
): Observable<Action> => action$.pipe(
	ofType(GET_PAYROLL_TASK_DISPLAY_SETTINGS_CALL),
	switchMap(
		({ payload }) => fromPromise(getPayrollTaskDisplaySettings(payload)).pipe(
			switchMap(res => of(getPayrollTaskDisplaySettingsDone({ res }))),
			catchError(error => of(getPayrollTaskDisplaySettingsFail({ error }))),
		),
	),
);
